import React, { useState } from 'react';
import './SelectItemDialog.css';
import { changeImgState, getOrderedButtons } from '../../Functions';

const SelectItemDialog = ({sel, type, setType, category,getStyleImg,setLoad,  Buttons, Tuxedo }) => {

    const [items, setItems] = useState([]);
    const [title, setTitle] = useState("")

    const onClose = ()=>{
        setType(null)
    }

    useState(()=>{

        if(type === "tuxedo"){
            setItems(Tuxedo)
            setTitle("Select Tuxedo")
        } else if(type === "button"){
            
            setItems(getOrderedButtons(sel, Buttons, "Coat"))
            setTitle("Select Button")
        }

    }, [Tuxedo, Buttons])

    const onItemClick = (item)=>{
        let obj = {...sel};

        if(type === "button"){
            // if(category === "suit"){
                // obj["fabric"]["Coat"]["button"] = item.id
                // obj["fabric"]["Coat"]["isButtonRequired"] = true

                // if (obj["fabric"] && obj["fabric"]["Vest"]) {
                //     obj["fabric"]["Vest"]["button"] = item.id;
                //     obj["fabric"]["Vest"]["isButtonRequired"] = true
                // }
                obj["button"] = {
                  id : item.id,
                  src : item.src,
                }
                callStyleFunction(obj)
            // }
        } else if(type === "tuxedo"){
            obj["tuxedo"] = {...item}
            callStyleFunction(obj)
        }

    }

    const callStyleFunction = (obj)=>{
        setLoad(true)
                
        getStyleImg(obj)
    }
  return (
    <div className="select_style_dialog_overlay">
      <div className="select_style_dialog_container">
        <div className="select_style_dialog_header">
          <h2 className="select_style_dialog_title">{title}</h2>
          <button
            className="select_style_dialog_close_button"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="select_style_dialog_items_grid">
          {items.map((item, index) => (
            <div
              key={index}
              className="select_style_dialog_item_card"
              onClick={() => onItemClick(item)}
            >
              <div className="select_style_dialog_image_container">
                <img
                  src={item.src}
                  alt={item.name}
                  className="select_style_dialog_item_image"
                />
              </div>
              <div className="select_style_dialog_item_name">{item.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SelectItemDialog;
